import { InterviewQuestionResponseModel, QuestionAnswerDto } from "./QuestionModels"

export interface KeyValuePair<T, T1> {
    key: T
    value: T1
}

export interface PickedLocation {
    country: string
    city?: string
    street?: string
    streetNumber?: string
}
export class UploadedFileModel {
    image: File
    description: string
    id?: string

    public get title(): string {
        return this.image.name
    }
    public set value(v: string) {
        new File([this.image.slice(0, this.image.size, this.image.type)], v, { type: this.image.type })
    }

    constructor(img: File, descr: string) {
        this.image = img
        this.description = descr
    }
}
export interface UploadedFilesResponse {
    id?: number
    title?: string
    description?: string
    mediaUrl?: string
    isUploaded: boolean
}

/**
 * Dictionary key suffixes under InterviewQuestionary.UploadFiles.Errors.
 * The service throws a code, the component resolves it to a translation,
 * which keeps questionary.service free of any store dependency.
 */
export type UploadErrorCode = 'RequestTooLarge' | 'UploadFailed'

export class UploadError extends Error {
    code: UploadErrorCode

    constructor(code: UploadErrorCode) {
        super(code)
        this.code = code
        this.name = 'UploadError'
    }
}

/**
 * Detects by property rather than `instanceof`: the build downlevels through Babel,
 * where `instanceof` against an Error subclass is not reliable.
 */
export function isUploadError(error: unknown): error is UploadError {
    return error instanceof Error && typeof (error as UploadError).code === 'string'
}

export interface QuestionarySubmitDto {
    qas: QuestionAnswerDto[]
    isWithAdditionalQuestions: boolean
}
export interface StoryCreatedResponse {
    StoryId: number
    AdditionalQuestions: InterviewQuestionResponseModel[]
}
export interface LinkDto {
    Name?: string
    Target?: string
    Url?: string
}

export interface ShareLink {
    Icon: string,
    Link: string,
    LinkMobile: string,
    LinkName: string
}

export interface MediaDto {
    Url: string
    Alt: string
    Type: MEDIA_TYPE
}

export enum MEDIA_TYPE{
    Image = 0,
    Video = 1,
    Audio = 2
}